import React from 'react';

const RootsComponent = () => {
  const root="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/Roots+and+Wings%2C+3lens+and+LSG/root.svg";
  return (
    <div className="bg-white">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="flex flex-col md:flex-row items-center gap-8">
          {/* Image side */}
          <div className="w-full md:w-2/5">
            <img 
              src={root} 
              alt="Strong roots tree" 
              className="rounded-lg w-full h-auto object-cover"
            />
          </div>
          
          {/* Content side */}
          <div className="w-full md:w-3/5">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">Roots</h2>
            <h3 className="text-lg font-medium text-gray-800 mb-4">Built on Strength. Grown with Discipline.</h3>
            
            <p className="text-gray-700 mb-4">
              Like a well-rooted tree that can weather any storm, we invest in companies 
              with strong financial foundations. These businesses have:
            </p>
            
            <ul className="mb-4 space-y-2">
              {[
                'Very low debt levels',
                'Growth powered by internal cash flows and real demand',
                'High Return on Equity (ROE) and Return on Capital Employed (ROCE)',
                'Strong promoter ownership and operational expertise'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-gray-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <p className="text-gray-700">
              We avoid companies that rely heavily on borrowed funds or have weak fundamentals. 
              Instead, we favour those that consistently reward shareholders and are run by 
              experienced, accountable promoters.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RootsComponent;